import React, { useState } from 'react';
import { ScheduleWrapper, SubTitle, TabItem, TabsContainer } from './ScheduleOrderWrapper.styled';
import { faCalendarAlt, faForward } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScheduleContentOrder } from './ScheduleContentOrder';
import dayjs from 'dayjs';
import { state } from '../../../types/store/state';
import { useSelector } from 'react-redux';

import { useTranslation } from 'next-i18next';

interface ScheduleOrderWrapperProps {
  programmedTime: string;
  setProgrammedTime: (time: string) => void;
}

export const ScheduleOrderWrapper = ({ programmedTime, setProgrammedTime }: ScheduleOrderWrapperProps) => {
  const { t } = useTranslation();
  const cart = useSelector(({ cart }: state) => cart);
  const [deliveryTime, setDeliveryTime] = useState(
    programmedTime !== '' ? 'schedule' : 'now'
  );
  const [isScheduleVisible, setScheduleVisible] = useState(false);

  const handleProcessNow = () => {
    setProgrammedTime('');
    setDeliveryTime('now');
    setScheduleVisible(false);
  };

  const handleSchedule = () => {
    setDeliveryTime('schedule');
    setScheduleVisible(true);
    setProgrammedTime('');
  };

  const closeSchedule = (isClosed: boolean) => {
    setScheduleVisible(!isClosed);
  };

  return (
    <ScheduleWrapper>
      <SubTitle>{t('ScheduleOrder.select.title')}</SubTitle>
      <TabsContainer>
        <TabItem
          onClick={handleProcessNow}
          isSelected={deliveryTime === 'now'}
        >
          <FontAwesomeIcon icon={faForward} width={16} className="faIcon" />
          {t('ScheduleOrder.tab.programNow.title')}
        </TabItem>
        <TabItem
          onClick={handleSchedule}
          isSelected={deliveryTime === 'schedule'}
        >
          <FontAwesomeIcon icon={faCalendarAlt} width={16} className="faIcon" />
          {t('ScheduleOrder.tab.programSchedule.title')}
        </TabItem>
      </TabsContainer>

      {deliveryTime === 'schedule' && isScheduleVisible && (
        <>
          <SubTitle>{t('ScheduleOrder.programOrder.title')}</SubTitle>
          <ScheduleContentOrder
            branchStoreId={cart.branchStores[0]?.id}
            setProgrammedTime={setProgrammedTime}
            closeSchedule={closeSchedule}
            handleProcessNow={handleProcessNow}
          />
        </>
      )}

      {deliveryTime === 'schedule' && programmedTime ? (
        <SubTitle>
          {t('ScheduleOrder.orderScheduledToAt.title', {
            date: dayjs(new Date(programmedTime)).format('MMMM DD'),
            time: dayjs(new Date(programmedTime)).format('hh:mm A')
          })}
        </SubTitle>
      ) : deliveryTime === 'now' ? (
        <SubTitle>{t('ScheduleOrder.programNow.title')}</SubTitle>
      ) : null}

    </ScheduleWrapper>
  );
};
